// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__3gyOo","sub":"style_sub__2O-jI","title":"style_title___LeYE"};